import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom";
import { fetchThemeData } from "../themeSlice";
import { selectAdminToken, selectOrganizationId, selectSessionId } from "../sessionSlice";
import { updateThemeData } from "../functions/updateThemeData";
import "../stages.css";

const TABS = [
  { to: "/admin/rules", label: "Home" },
  { to: "/admin/editor", label: "Stage 1" },
  { to: "/admin/questions", label: "Stage 2" },
  { to: "/admin/words", label: "Stage 3" },
  { to: "/admin/jigsaw", label: "Stage 4" },
];

/** Selected theme + admin session, loading the theme when the page is opened directly. */
export function useAdminTheme() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const adminToken = useSelector(selectAdminToken);
  const organizationId = useSelector(selectOrganizationId);
  const sessionId = useSelector(selectSessionId);
  const { currentTheme, data, status } = useSelector((state) => state.theme);

  useEffect(() => {
    if (!adminToken) return;
    if (!data || (currentTheme && data.themename !== currentTheme)) {
      dispatch(fetchThemeData({ themeId: currentTheme, isAdmin: true }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [adminToken]);

  const reload = () => dispatch(fetchThemeData({ themeId: currentTheme, isAdmin: true })).unwrap();

  /** Save theme keys (same endpoint the original events.php handlers wrote to). */
  const save = async (values) => {
    await updateThemeData({
      payload: {
        data: values,
        organizationId: organizationId || "admin",
        sessionId: sessionId || "admin",
        currentTheme,
      },
      token: adminToken,
    });
    await reload();
  };

  return { adminToken, currentTheme: data?.themename || currentTheme, data, status, save, reload, navigate };
}

/** Home | Stage 1 | Stage 2 | Stage 3 | Stage 4 — header.php of the original admin. */
export default function StageTabs() {
  const navigate = useNavigate();
  return (
    <>
      <div className="back-button-holder">
        <button type="button" className="back-button" onClick={() => navigate("/admin")}>
          <i className="fa-solid fa-arrow-left" /> Themes
        </button>
      </div>
      <div className="bp-stage-container">
        {TABS.map((t) => (
          <NavLink key={t.to} to={t.to} className={({ isActive }) => `bp-stage${isActive ? " active" : ""}`}>
            {t.label}
          </NavLink>
        ))}
      </div>
    </>
  );
}
